module.exports = __webpack_public_path__ + "img/85.1.505941e7.jpg";